/**
 * CMSMenu extends the client-side Netx.Menu object with all the properties needed to save & retrieve a menu from the DAM.
 * @class
 */
import Base from '@netx/core/lib/netx-menu';

export default class CMSMenu extends Base {
	/**
	 * @type {Netx.Rpc}
	 * @private
	 */
	get rpc() {
		return true;
	}

	/**
	 * The unique ID for this model
	 * @type {string}
	 */
	get idAttribute() {
		return 'id';
	}

	/**
	 * @property {object}  defaults           - The default attribute values
	 * @property {string}  defaults.name      - non-mutable, portal-unique key (name + portalId == DAM-unique key for the object)
	 * @property {string}  defaults.label     - mutable label for the object
	 * @property {string}  defaults.portalId  - portal for this menu.  Not mutable.
	 * @property {number}  defaults.userId    - owner of this menu
	 * @property {string}  defaults.modDate   - set by server on update
	 * @property {array}   defaults.actions   - the array (possibly nested) of actions in this menu.
	 */
	get defaults() {
		return {
			// id: 0,
			name: '',
			label: '',
			portalId: '',
			userId: 0,
			modDate: '',
			actions: [],
		};
	}

	/** @property {array} */
	get gooAttrs() {
		return ['label', 'actions'];
	}

	/**
	 * RPC methods:
	 * @rpcs
	 */
	get methods() {
		return {
			/** @method save */
			create: [
				'setMenu',
				function () {
					return this.self();
				},
			],
			update: [
				'setMenu',
				function () {
					return this.self();
				},
			],
			/** @method fetch */
			read: () => {
				// TODO: something is trying to fetch this without a proper portal id
				if (!this.portalId) return $.Deferred().resolve();
				return ['getMenuForPortal', 'name', 'portalId'];
			},
			/** @method destroy */
			remove: ['deleteMenuForPortal', 'name', 'portalId'],
		};
	}

	/** @method */
	parse(result, opts) {
		if (_.isObject(result)) {
			this.set(this.unpackAttrs(result));
		} else if (_.isNumeric(result)) {
			this.set({id: result});
		}
	}

	/** @override */
	constructor(attrs, opts) {
		super(attrs, opts);

		if (this.get('goo')) {
			var gooAttrs = this.unpackAttrs(
				_.pick(this.attributes, this.gooAttrs, 'goo'),
			);
			this.set(gooAttrs);
		}
	}

	/** @method */
	fetchMenuForPortal(name, portalId) {
		this.set({
			name: name,
			portalId: portalId,
		});
		return this.fetch.apply(this, _.rest(arguments, 2));
	}

	/**
	 * Search for (recursively) and remove a given action from this menu.
	 * @param {string} event The event string to remove
	 * @param {array} actions Optional array to search; defalts to this.attributes.actions
	 * @return {number} Number of actions removed.
	 */
	removeAction(event, actions) {
		var removed = 0;
		actions = actions || this.get('actions');
		_.each(
			actions,
			function (item, idx, all) {
				if (item == event) {
					// Remove this item from the array
					actions.splice(idx, 1);
					removed++;
					// Replace the array with a clone, just to trigger BB change events:
					this.set('actions', _.clone(actions));
				} else if (_.isObject(item) && _.isArray(item.actions)) {
					// recurse through sub-menu:
					removed += this.removeAction(event, item.actions);
				}
			},
			this,
		);

		return removed;
	}

	/** @type {string} */
	static get __name__() {
		return 'CMSMenu';
	}
}
